import React, {useContext} from 'react'
import {AppFilter,AppTableSearchContext} from './AppTableSearchServer'
import {Icon} from 'antd'

interface AppTableFilterProps{
    filterList?:AppFilter[]
}

export const AppTableFilter = (props:AppTableFilterProps) =>{

    const {onCloseItem} = useContext(AppTableSearchContext)

    return (<div className='app-search-filter-list-container'>
        <div className='app-search-filter-list-outer'>
            <div className='app-search-filter-list-inner'>
                {props.filterList.map((filter:AppFilter,index)=>{
                    return (
                    <span 
                        key={index} 
                        onClick = {e=>onCloseItem(filter)}
                        className='app-search-filter-item-outer'>
                        <span>{filter.lable}：</span>
                        <span title={filter.describe} className='app-search-filter-item-text' >{filter.describe}</span>
                        <b className="app-search-filter-item-close">
                            <Icon
                                type="close"
                                className="app-search-filter-item-close-icon"
                            ></Icon>
						</b>
                    </span>)
                })}
            </div>
        </div>
    </div>);
}





// WEBPACK FOOTER //
// ./src/qcc/AppTableSearch/AppTableFilter.tsx